"use client";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import DropdownUser from "@/components/Add/DropdownUser";
import ThemeToggler from "./ThemeToggler";
import menuData from "./menuData";
import { Menu, X } from "lucide-react";

const Header = () => {
  // Navbar toggle
  const [navbarOpen, setNavbarOpen] = useState(false);
  const [login, setLogin] = useState(null);
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");

  const navbarToggleHandler = () => {
    setNavbarOpen(!navbarOpen);
  };

  // Sticky Navbar
  const [sticky, setSticky] = useState(false);
  const handleStickyNavbar = () => {
    if (window.scrollY >= 80) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleStickyNavbar, { passive: true });
    return () => window.removeEventListener("scroll", handleStickyNavbar);
  }, []);


  // submenu handler
  const [openIndex, setOpenIndex] = useState(-1);

  const handleSubmenu = (index) => {
    if (openIndex === index) {
      setOpenIndex(-1);
    } else {
      setOpenIndex(index);
    }
  };

  const usePathName = usePathname();

  useEffect(() => {
    const login =localStorage.getItem("login")
    // const Dnombre =localStorage.getItem("nombre")
    // const Dapellido =localStorage.getItem("apellido")
    if(login=="true"){
      setLogin(true);
      // setNombre(Dnombre);
      // setApellido(Dapellido);
    }
    else setLogin(false)
  }, []);

  return (
    <>
      <header
        className={`header left-0 top-0 z-40 flex w-full items-center ${
          sticky
            ? "fixed z-[9999] bg-gray-dark !bg-opacity-70 shadow-sticky-dark backdrop-blur-sm transition"
            : "absolute bg-gray-dark !bg-opacity-60"
        }`}
      >
        <div className="container">
          <div className="relative -mx-4 flex items-center justify-between">
            <div className="w-60 max-w-full px-4 xl:mr-12">
              <Link href="/" className={`header-logo block w-full ${sticky ? "py-3 lg:py-2" : "py-5 lg:py-2"} `}>
                <Image
                  src="/images/logo/logo-dark-low.png"
                  alt="logo"
                  width={120}
                  height={60}
                  priority
                  className="w-30 h-auto"
                />
              </Link>
            </div>

            <div className="flex w-full items-center justify-between px-4 gap-8">
              <div>
                <button
                  onClick={navbarToggleHandler}
                  id="navbarToggler"
                  aria-label="Mobile Menu"
                  className="absolute right-4 top-1/2 block -translate-y-1/2 rounded-lg px-3 py-[6px] ring-primary focus:ring-2 lg:hidden"
                >
                  <span className="block transition-transform duration-200 ease-out">
                    {navbarOpen ? (<X className="h-7 w-7 text-white" />) : (<Menu className="h-7 w-7 text-white" />)}
                  </span>
                </button>
                <nav
                  id="navbarCollapse"
                  className={`navbar font-semibold absolute group-text-semibold right-0 z-30 w-[250px] rounded border-[.5px] border-body-color/20 bg-dark px-6 py-4 duration-300 lg:visible lg:static lg:w-auto lg:border-none lg:!bg-transparent lg:p-0 lg:opacity-100 ${
                    navbarOpen
                      ? "visibility top-full opacity-100"
                      : "invisible top-[120%] opacity-0"
                  }`}
                >
                  <ul className="block lg:flex lg:space-x-4 xl:space-x-8 2xl:space-x-12">
                    {menuData.map((menuItem, index) => (
                      <li key={index} className="group relative">
                        {menuItem.path ? (
                          <Link
                            href={menuItem.path}
                            className={`flex py-2 text-xs md:text-sm lg:text-md lg:mr-0 lg:inline-flex lg:px-0 lg:py-6 ${
                              usePathName === menuItem.path
                                ? "text-white"
                                : "text-white/95 hover:text-primary"
                            }`}
                          >
                            {menuItem.title}
                          </Link>
                        ) : (
                          <>
                            <p
                              onClick={() => handleSubmenu(index)}
                              className="flex cursor-pointer items-center justify-between py-2 text-xs md:text-sm lg:text-md text-white group-hover:text-white lg:mr-0 lg:inline-flex lg:px-0 lg:py-6"
                            >
                              {menuItem.title}
                              <span className="pl-3">
                                <svg width="25" height="24" viewBox="0 0 25 24">
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M6.29289 8.8427C6.68342 8.45217 7.31658 8.45217 7.70711 8.8427L12 13.1356L16.2929 8.8427C16.6834 8.45217 17.3166 8.45217 17.7071 8.8427C18.0976 9.23322 18.0976 9.86639 17.7071 10.2569L12 15.964L6.29289 10.2569C5.90237 9.86639 5.90237 9.23322 6.29289 8.8427Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                            </p>
                            <div
                              className={`submenu relative left-0 top-full rounded-3xl bg-dark/95  transition-[top] duration-300 group-hover:opacity-100 lg:invisible lg:absolute lg:top-[110%] lg:block lg:w-[250px] lg:p-4 lg:opacity-0 lg:shadow-lg lg:group-hover:visible lg:group-hover:top-full ${
                                openIndex === index ? "block" : "hidden"
                              }`}
                            >
                              {menuItem.submenu.map((submenuItem, index) => (
                                <Link
                                  href={submenuItem.path}
                                  key={index}
                                  className="block rounded py-2.5 text-sm md:text-md text-white hover:text-primary lg:px-3"
                                >
                                  {submenuItem.title}
                                </Link>
                              ))}
                            </div>
                          </>
                        )}
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
              <div className="flex items-center justify-end pr-16 lg:pr-0 min-w-[150px]"> 
                
                {login === true && <DropdownUser />}

                {login === false && (
                  <Link
                    href="/signin"
                    className="hidden md:block rounded-3xl text-center px-4 py-2 md:px-4 lg:px-6 xl:px-8 text-xs lg:text-sm font-semibold text-white bg-udaxenc1 shadow-btn transition duration-300 ease-in-up hover:bg-opacity-90 hover:shadow-btn-hover"
                  >
                    Iniciar Sesión
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
